import { FormRules, StationManagementDetails, StationSectionDataField } from "../types"
import { RANDOM_BIG_NUMBER } from "../constants/numbers";
import createRules from "./createRules";

const createEditDetailRules = (item: StationSectionDataField, details: StationManagementDetails | null): FormRules => {
	return createRules({
		...item.rules!,
		...(item.id === 'maxKits' ?
			{
				maxKits: {
					...item.rules!.maxKits,
					classValidator: (value: number) => value >= +details!.purchasedKits && value < RANDOM_BIG_NUMBER && value > 19
				}
			} :
			{})
	})
}

export default createEditDetailRules;